import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

import { FormatPipe } from '@softline/ui-core';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-faelldt-list-view',
  imports: [
    FormatPipe
  ],
  templateUrl: './faelldt.list-view.html',
  styleUrls: ['./faelldt.list-view.css'] })
export class FaelldtListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
